



















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { ICaseTypeInput } from '@/modules/Case/interfaces/case-form'
import { caseTypeValues } from '@/modules/Case/helpers/case'

@Component({})
export default class CaseFormType extends Vue {
  @Prop({ type: Object as () => ICaseTypeInput }) value!: ICaseTypeInput
  @Prop({ type: Boolean }) disabled!: boolean

  caseTypeIndex = 0
  caseTypeOptions = caseTypeValues

  caseTypeClass: string[] = [
    'c-case__case-type-dialog-item-newbusiness', 'c-case__case-type-dialog-item-renewal', 'c-case__case-type-dialog-item-rewrite', 'c-case__case-type-dialog-item-remarket', 'c-case__case-type-dialog-item-cancellation', 'c-case__case-type-dialog-item-endorsement', 'c-case__case-type-dialog-item-bor', 'c-case__case-type-dialog-item-coi'
  ]
  caseTypeCheckedClass: string[] = [
    'c-case__case-type-dialog-item-newbusiness-on', 'c-case__case-type-dialog-item-renewal-on', 'c-case__case-type-dialog-item-rewrite-on', 'c-case__case-type-dialog-item-remarket-on', 'c-case__case-type-dialog-item-cancellation-on', 'c-case__case-type-dialog-item-endorsement-on', 'c-case__case-type-dialog-item-bor-on', 'c-case__case-type-dialog-item-coi-on'
  ]

  @Watch('caseTypeIndex')
  onCaseTypeChanged (val: number) {
    this.$emit('input', {
      caseTypeIdx: val
    })
  }

  handleClick (index: number) {
    if (this.disabled) {
      return
    }
    this.caseTypeIndex = index
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
